/**
 * AllModern SVG logo
 *
 * @author    Steve Dennett <sdennett@wayfair.com>
 * @copyright 2018 Wayfair LLC - All rights reserved
 */
import React from 'react';
import BaseLogo from './BaseLogo';

// The unique aspect ratio of the Allmodern store logo, this ensures consistent height based off of the width
const ASPECT_RATIO = 0.13905817174;

const AllModernLogo = (props) => {
  return (
    <BaseLogo
      {...props}
      aspectRatio={ASPECT_RATIO}
      aria-label="AllModern"
      viewBox="0 0 541.5 75.3"
      fill="#102529"
    >
      <title>AllModern</title>
      <path d="M70.7,74.2v-73h13.7V62h31.7v12.2H70.7z" />
      <path d="M122.2,74.2v-73h13.7V62H168v12.2H122.2z" />
      <path d="M224.7,73.6V31.7L211,59h-9.5l-13.8-27.3v41.9h-14V1.7h13.8l18.8,38.9l18.7-38.9h13.8v71.9H224.7z" />
      <path
        d="M294.5,67.2c-5.2,5.2-11.5,8.1-20,8.1c-8.4,0-14.9-2.9-20.1-8.1c-7.5-7.5-7.3-16.7-7.3-29.5
        c0-12.8-0.2-22.1,7.3-29.5c5.2-5.2,11.7-8.1,20.1-8.1c8.4,0,14.8,2.9,20,8.1c7.5,7.5,7.4,16.8,7.4,29.5
        C301.9,50.5,302,59.7,294.5,67.2z M283.8,16.9c-2.1-2.4-5.3-4-9.3-4c-4,0-7.3,1.6-9.4,4c-2.8,3.1-3.5,6.6-3.5,20.8
        s0.7,17.7,3.5,20.8c2.1,2.4,5.4,4,9.4,4c4,0,7.2-1.6,9.3-4c2.8-3.1,3.6-6.6,3.6-20.8S286.6,20,283.8,16.9z"
      />
      <path
        d="M355.3,66.7c-4.7,4.7-11.5,6.9-19,6.9h-25.9V1.7h25.9c7.5,0,14.2,2.1,19,6.9c8.1,8.1,7.3,18,7.3,28.8
        C362.6,48.2,363.4,58.7,355.3,66.7z M345.5,18.7c-2.4-2.9-5.7-4.4-10.5-4.4h-10.6v46.8H335c4.8,0,8.1-1.5,10.5-4.4
        c2.6-3.2,3-8.4,3-19.3S348.2,21.9,345.5,18.7z"
      />
      <path d="M369.5,73.6V1.7h47.4v12.5h-33.3v16.9h28.4v12.5h-28.4v17.5h33.3v12.5H369.5z" />
      <path
        d="M463.7,73.6l-14-28.7h-10.1v28.7h-14V1.7h28.2c14.6,0,23.3,10,23.3,22c0,10.1-6.2,16.4-13.1,18.9l16.1,31H463.7
        z M452.8,14.2h-13.2v19h13.2c6.2,0,10.2-3.9,10.2-9.5C463,18.2,459,14.2,452.8,14.2z"
      />
      <path d="M529,73.8l-28.5-44.1v44.1h-14V1.9H499l28.5,44V1.5h14v72.3H529z" />
      <path d="M49.1,73.8L44.8,61H19.1l-4.4,12.8H0L26.3,1.5h11.1l26.4,72.4H49.1z M32.2,22.8l-9.1,26.3h18L32.2,22.8z" />
    </BaseLogo>
  );
};

export default AllModernLogo;
